export type SpeechLifecycle = {
  onStart?: () => void;
  onEnd?: () => void;
  onError?: () => void;
};

export async function configureMathliveSpeech(lifecycle?: SpeechLifecycle) {
  const mod = await import("mathlive");
  type MathfieldElementStatic = {
    fontsDirectory: string;
    soundsDirectory: string;
    speakHook?: (text: string) => void;
    readAloudHook?: (element: unknown, text: string) => void;
    speechEngine?: "amazon" | "local";
    speechEngineRate?: string;
    textToSpeechRules?: "sre" | "mathlive";
    textToSpeechMarkup?: "" | "ssml" | "ssml_step" | "mac";
  };
  const MathfieldElement = (
    mod as unknown as { MathfieldElement?: MathfieldElementStatic }
  ).MathfieldElement;
  if (!MathfieldElement) return;
  // Use MathLive's default fonts and sounds from its package instead of custom paths
  // This works better for npm packages where asset paths are relative
  // MathfieldElement.fontsDirectory = "/fonts";
  // MathfieldElement.soundsDirectory = "/sounds";
  try {
    (MathfieldElement as unknown as { speechEngine?: string }).speechEngine =
      "local" as unknown as never;
    (
      MathfieldElement as unknown as { textToSpeechRules?: string }
    ).textToSpeechRules = "mathlive" as unknown as never;
    (
      MathfieldElement as unknown as { textToSpeechMarkup?: string }
    ).textToSpeechMarkup = "" as unknown as never;
    (
      MathfieldElement as unknown as { speechEngineRate?: string }
    ).speechEngineRate = "medium" as unknown as never;
    MathfieldElement.speakHook = (text: string) => {
      try {
        if (typeof window !== "undefined" && "speechSynthesis" in window) {
          window.speechSynthesis.cancel();
          const utterance = new SpeechSynthesisUtterance(text);
          utterance.lang =
            typeof navigator !== "undefined" && navigator.language
              ? navigator.language
              : "en-US";
          utterance.rate = 1.0;
          if (lifecycle?.onStart) utterance.onstart = lifecycle.onStart;
          if (lifecycle?.onEnd) utterance.onend = lifecycle.onEnd;
          if (lifecycle?.onError) utterance.onerror = lifecycle.onError;
          window.speechSynthesis.speak(utterance);
        }
      } catch {
        lifecycle?.onError?.();
      }
    };
    MathfieldElement.readAloudHook = (_element: unknown, text: string) => {
      try {
        MathfieldElement.speakHook?.(text);
      } catch {}
    };
  } catch {}
}
